import React, { useState, useEffect, Children, cloneElement } from 'react';
import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';
import { useTheme } from '../../ThemeContext';

import {
  Wrapper,
  Holder,
  Panel,
  Close,
  CloseIcon,
  Content,
} from './Modal.style';

const Modal = ({ children, handleClose = () => {}, fullscreen = false }) => {
  const intl = useIntl();
  const theme = useTheme();
  const [closingInitiator, setClosingInitiator] = useState(undefined);
  const [openModal, setOpenModal] = useState(false);
  const [closeModal, setCloseModal] = useState(false);

  useEffect(() => {
    setOpenModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseModal = () => {
    setOpenModal(false);
    setCloseModal(true);
    setTimeout(() => {
      handleClose();
    }, 100);
  };

  const childrenElement = Children.map(children, (child, index) =>
    cloneElement(child, {
      index,
      handleCloseModal,
    })
  );

  return (
    <Wrapper>
      <Holder
        theme={theme.modal.holder}
        open={openModal ? true : undefined}
        close={closeModal ? true : undefined}
        onPointerDown={(event) => {
          if (event.currentTarget === event.target) setClosingInitiator(true);
          else if (closingInitiator) setClosingInitiator(false);
        }}
        onPointerUp={(event) => {
          if (closingInitiator && event.currentTarget === event.target)
            handleCloseModal();
        }}
      >
        <Panel
          theme={theme.modal.panel}
          open={openModal ? true : undefined}
          close={closeModal ? true : undefined}
          fullscreen={fullscreen}
        >
          <Close
            theme={theme.modal.close}
            title={intl.formatMessage({ id: 'MODAL.CLOSE' })}
            onClick={() => {
              handleCloseModal();
            }}
          >
            <CloseIcon className='material-icons'>close</CloseIcon>
          </Close>
          <Content fullscreen={fullscreen}>{childrenElement}</Content>
        </Panel>
      </Holder>
    </Wrapper>
  );
};

Modal.propTypes = {
  handleClose: PropTypes.func,
  children: PropTypes.node,
  fullscreen: PropTypes.bool,
};

export default Modal;
